module.exports = __webpack_public_path__ + "img/psd.94a4fb5f.svg";